import React from 'react'
import { Trans } from '@lingui/react/macro'

import { SameAs } from '../../_components/SameAs'

import { useFooterData } from './data'
import FooterItem from './_components/FooterItem'

import type { ICommonFooterProps } from '@/layouts/type'

import LanguageSwitcher from '@/components/LanguageSwitcher'


import { cls } from 'tagged-classnames-free';
import { CssIcon } from '@/components/CssIcon';
export default function Footer(props: ICommonFooterProps) {
  const { style, className, locales } = props
  const footerData = useFooterData()
  const fullYear = new Date().getFullYear()

  return (
    <footer
      style={style}
      className={cls`bg-f-bg-base text-f-text-tertiary ${className}`}
    >
      <div className='mx-auto flex w-full flex-col items-start gap-[150px] px-4 py-10 text-sm md:max-w-[1200px] md:flex-row md:flex-wrap'>
        <div className='w-full min-w-0 sm:min-w-[360px] md:w-auto'>
          <div className='mb-4 flex items-center justify-between gap-4 md:gap-20'>
            <CssIcon
              className='i-cus--tad-logo opacity-80'
              style={{
                width: 103,
                height: 28,
              }}
            />
            {!locales || (locales && locales.length > 0) ? (
              <LanguageSwitcher locales={locales ?? []} />
            ) : null}
          </div>
          <p className='mb-5 text-sm md:mb-8'>
            <Trans>© {fullYear} Tad.ai. All rights reserved.</Trans>
          </p>
          <div>
            <p className='mb-3'>
              <Trans>Share</Trans>
            </p>
            <SameAs />
          </div>
        </div>
        <div className='flex w-full min-w-0 flex-wrap gap-x-4 gap-y-6 md:flex-1 md:flex-nowrap md:justify-end md:gap-8'>
          {footerData.map((item) => {
            return (
              <div key={item.categoryTitle} className='w-full sm:w-[160px]'>
                <p className='text-f-text-tertiary mb-3 text-sm'>
                  {item.categoryTitle}
                </p>
                <ul className='text-f-text-secondary columns-1 gap-6 lg:gap-10 [&>li:first-child]:mt-0 [&_a]:whitespace-normal [&_a]:break-words'>
                  {item.children.map((child) => {
                    return (
                      <FooterItem
                        key={`${child.href ?? child.label}`}
                        {...child}
                      />
                    )
                  })}
                </ul>
              </div>
            )
          })}
        </div>
      </div>
    </footer>
  )
}
